require('es6-promise').polyfill();

import React from "react";
import { AddressTypeaheadEquifaxWithFallback } from "./components/AddressTypeaheadEquifaxWithFallback";

declare global {
  interface Window { Datalive: any; }
}
window.Datalive = window.Datalive || {};
window.Datalive.AddressTypeaheadEquifax = AddressTypeaheadEquifaxWithFallback;

export default AddressTypeaheadEquifaxWithFallback;
